/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './actionTypes';

const initialState = {
  selectedRebateProgram: {
    plan: '',
    rebateProgram: 'MDFD',
    allManufacturers: true,
    singleManufacturer: null,
  },
  rebateProgramList: [],
  manufactureList: [],
  errorList: [],
  checkFlag: false,
  firstload: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SELECTED_REBATE_PROGRAM:
      return { ...state, selectedRebateProgram: action.payload };
    case ActionTypes.ASSIGN_DISPUTE_DETAIL:
      if (action.payload?.data.length !== 0) {
        return { ...state, disputeDetail: action.payload };
      } else {
        const data = { ...state.disputeDetail };
        data['dataEmpty'] = !data.dataEmpty;
        return { ...state, disputeDetail: data };
      }
    case ActionTypes.ERROR_LIST:
      return { ...state, errorList: [...action.payload] };
    case ActionTypes.REBATE_PROGRAM_LIST:
      return { ...state, rebateProgramList: action.payload };
    case ActionTypes.MANUFACTURER_LIST:
      return { ...state, manufactureList: action.payload };
    case ActionTypes.RESET_STATE:
      return initialState;
    case ActionTypes.CHECK_FLAG:
      return { ...state, checkFlag: action.payload };
    case ActionTypes.GET_PLAN_TYPE:
      return { ...state, planType: action.payload };
    case ActionTypes.FIRST_LOAD:
      return { ...state, firstload: action.payload };
    default:
      return state;
  }
};

export default reducer;
